import MypageWishlistContainer from './MypageWishlistContainer';
export default MypageWishlistContainer;
